module.exports = __webpack_public_path__ + "img/美赞成.215d07b7.png";